import React, { Component } from 'react';
import '../styles.css';
import { connect } from 'react-redux';
import * as f from '../logic';
import { setPlayerToStart } from '../REDUX/actions';
import Player1Icon from '../ASSETS/player1.png';
import Pie from '../COMPONENTS/Pie';
import { PLAYER1, PLAYER2 } from '../const';
import _ from 'lodash';

class TopBar extends Component {
  handleClickPlayer = player => e => {
    this.props.setPlayerToStart(player);
  };

  render() {
    let { currentPlayer, stats } = this.props;
    const totalArea = f.totalArea(this.props.size);
    const area1 = f.playerArea(PLAYER1, this.props);
    const area2 = f.playerArea(PLAYER2, this.props);
    const score1 = Math.round((area1 * 100) / totalArea);
    const score2 = area1 + area2 === totalArea ? 100 - score1 : Math.round((area2 * 100) / totalArea);
    const { winner } = f.winnerInfo(this.props);
    const color1 = 'rgb(255, 128, 255)';
    const color2 = 'rgb(0, 221, 221)';
    const clsNonCurrentPlayer = `non-current-player ${f.gameStarted(this.props) ? '' : 'pointer'}`;

    const styles = {
      stats: { color: 'orange', margin: '0 15px 0 5px' },
    };

    if (!stats || _.isEmpty(stats)) {
      stats = { plays: 0, wins1: 0, wins2: 0, ave: 0, best: 0 };
    }

    return (
      <div className="topbar">
        <div className="statsbar">
          <span style={{ gridArea: '1/1', justifySelf: 'start', color: color1 }}>{stats.wins1}</span>
          <div style={{ gridArea: '1/1', justifySelf: 'center', marginLeft: '15px' }}>
            Plays<span style={styles.stats}>{stats.plays}</span>
            {f.solo(this.props) ? (
              <>
                Best<span style={styles.stats}>{stats.best}%</span>
                Ave<span style={styles.stats}>{stats.ave}%</span>
              </>
            ) : null}
          </div>
          <span style={{ gridArea: '1/1', justifySelf: 'end', color: color2 }}>{stats.wins2}</span>
        </div>
        <div className="scorebar">
          <span
            className={!winner && currentPlayer === PLAYER1 ? 'current-player' : clsNonCurrentPlayer}
            style={{ gridArea: '1/1', justifySelf: 'start' }}
            onClick={this.handleClickPlayer(PLAYER1)}
          >
            <img src={Player1Icon} height="80" alt="Player 1" />
          </span>
          <span style={{ gridArea: '1/2', textAlign: 'center', marginRight: '10px', color: color1 }}>{score1}%</span>
          <div className="pie-and-grade">
            <Pie width="70" height="70" p1={score1} p2={score2} />
            <span className="pie" />
            {f.solo(this.props) ? (
              <div className="grade">
                Grade<div style={{ fontSize: '16px' }}>{stats.grade}</div>
              </div>
            ) : null}
          </div>
          <span style={{ gridArea: '1/4', textAlign: 'center', marginLeft: '10px', color: color2 }}>{score2}%</span>
          <span
            className={!winner && currentPlayer === PLAYER2 ? 'current-player' : clsNonCurrentPlayer}
            style={{ gridArea: '1/5', justifySelf: 'end' }}
            onClick={this.handleClickPlayer(PLAYER2)}
          >
            <img src={f.skillIcon(this.props)} height="80" alt="Player 2" />
          </span>
        </div>
      </div>
    );
  }
}

function mapStateToProps({ ta, common }) {
  return { ...ta, ...common };
}

export default connect(
  mapStateToProps,
  { setPlayerToStart }
)(TopBar);
